import React from 'react';
import Gallery from 'react-photo-gallery';
import Lightbox from 'react-image-lightbox';
import SelectedImage from './SelectedImage';

import 'react-image-lightbox/style.css';
import 'styles/gallery.scss';

class ReactPhotoGallery extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentImage: 0,
        };
        this.closeLightbox = this.closeLightbox.bind(this);
        this.openLightbox = this.openLightbox.bind(this);
        this.gotoNext = this.gotoNext.bind(this);
        this.gotoPrevious = this.gotoPrevious.bind(this);
    }
    openLightbox(event, obj) {
        this.setState({
            currentImage: obj.index,
            lightboxIsOpen: true,
        });
    }
    closeLightbox() {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    }
    gotoPrevious() {
        this.setState({
            currentImage: this.state.currentImage - 1,
        });
    }
    gotoNext() {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    }

    render() {

        return (
            <div className='tile'>
                <Gallery
                    photos={this.props.photoset}
                    onClick={this.openLightbox}
                    ImageComponent={SelectedImage} 
                />
                {this.state.lightboxIsOpen && (
                <Lightbox
                    images={this.props.photoset}
                    imageTitle={<div>{this.props.photoset[this.state.currentImage].title}</div>}
                    imageCaption={<div>{this.props.photoset[this.state.currentImage].caption}</div>}
                    onCloseRequest={this.closeLightbox}
                    onMovePrevRequest={this.gotoPrevious}
                    onMoveNextRequest={this.gotoNext}
                    mainSrc={this.props.photoset[this.state.currentImage].src}
                    prevSrc={this.state.currentImage === 0 ? null : this.props.photoset[this.state.currentImage - 1].src}
                    nextSrc={this.state.currentImage === this.props.photoset.length - 1 ?
                        null : this.props.photoset[this.state.currentImage + 1].src}
                    isOpen={this.state.lightboxIsOpen}
                    reactModalStyle={{
                        content: {
                            zIndex: 10000,
                        }
                    }}
                />)}
                <p />
            </div>

        )
    }
}

export default ReactPhotoGallery;



// WEBPACK FOOTER //
// ./src/components/GalleryPage/ReactPhotoGallery.js